import { render } from "./TotalProfit.vue?vue&type=template&id=28fdb09f&scoped=true"
import script from "./TotalProfit.vue?vue&type=script&lang=js"
export * from "./TotalProfit.vue?vue&type=script&lang=js"

import "./TotalProfit.vue?vue&type=style&index=0&id=28fdb09f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fdb09f"]])

export default __exports__